import React from "react";
import { Router, Route, Redirect } from "react-router-dom";
import Login from "./login/Login";
import Guru from "./dashboard/content/guru/Guru";
import AddGuru from "./dashboard/content/guru/AddGuru";
import Gurumapel from "./dashboard/content/guru/mgtMapel/MgtMapel";
import Siswa from "./dashboard/content/siswa/Siswa";
import CetakAkunSiswa from "./dashboard/content/siswa/CetakAkunSiswa";
import ImportSiswa from "./dashboard/content/siswa/import/ImportSiswa";
import UpdateJenjang from "./dashboard/content/siswa/updatejenjang/UpdateJenjang";
import Exam from "./dashboard/content/exam/Exam";
import Kelas from "./dashboard/content/kelas/Kelas";
import history from "../history";
import Bottom from "./navbar/Bottom";
import Dashboard from "./dashboard/Dashboard";
import { cekCookies } from "../actions";
import { connect } from "react-redux";
import ExamSoal from "./dashboard/content/exam/ExamSoal";
import JadwalExam from "./dashboard/content/exam/JadwalExam";
import ImportSoal from "./dashboard/content/banksoal/ImportSoal";
import MgtSoal from "./dashboard/content/banksoal/MgtSoal";
import GuruKelas from "./dashboard/content/guru/mgtGuruKelas/GuruKelas";
import Rekap from "./dashboard/content/rekapitulasi/exam/Rekap";
import EditSoal from "./dashboard/content/banksoal/EditSoal";
import RekapExam from "./dashboard/content/rekapitulasi/exam/RekapExam";
import RekapAgcu from "./dashboard/content/rekapitulasi/agcu/RekapAgcu";
import RekapExamDetail from "./dashboard/content/rekapitulasi/exam/RekapExamDetail";
import Homework from "./dashboard/content/homework/Homework";
import JadwalHomework from "./dashboard/content/homework/JadwalHomework";
import ReportHw from "./dashboard/content/homework/ReportHw";
import Learning from "./dashboard/content/learning/Learning";
import SoalForm from "./dashboard/content/learning/SoalForm";
import LearningKonten from "./dashboard/content/learning/LearningKonten";
import TeksForm from "./dashboard/content/learning/TeksForm";
import VideoForm from "./dashboard/content/learning/VideoForm";
import KoreksiEssay from "./dashboard/content/homework/KoreksiEssay";
import ViewKonten from "./dashboard/content/learning/ViewKonten";
import ReportDinasAgcu from "./dashboard/content/rptacgu/ReportDinasAgcu";
import ReportDinasAgcuPreview from "./dashboard/content/rptacgu/ReportDinasAgcuPreview";
import ReportDinasToo from "./dashboard/content/rpttoo/ReportDinasToo";
import ReportDinasTooPreview from "./dashboard/content/rpttoo/ReportDinasTooPreview";
import MigrasiBankSoal from "./dashboard/content/migrasi/MigrasiBankSoal";
import MigrasiBab from "./dashboard/content/migrasi/MigrasiBab";
import ResetPengerjaan from "./dashboard/content/reset/ResetPengerjaan";
import ResetUsername from "./dashboard/content/reset/ResetUsername";
import ReportLive from "./dashboard/content/reportLive/ReportLive";
import ReportHwKelas from "./dashboard/content/homework/ReportHw01";
import ReportHwExcel from "./dashboard/content/homework/ReportHwExcel";
import ReportHwDetailJawaban from "./dashboard/content/homework/ReportHwDetailJawaban";
import ListJadwal from "./dashboard/content/report/tryout/ListJadwal";
import ReportCbt from "./dashboard/content/report/tryout/ReportCbt";
import Aktivitasuphis from "./dashboard/content/aktivitas/Aktivitasuphis";
import AktivitasHw from "./dashboard/content/aktivitas/AktivitasHw";
import Comparasi from "./dashboard/content/report/comparasi/Comparasi";
import Vc from "./dashboard/content/vc/Vc";
import UpdKelasParalelSiswa from "./dashboard/content/siswa/siswakelasparalel/SiswaKp";
import DetailExamSiswa from "./dashboard/content/rekapitulasi/exam/DetailExamSiswa";
import ImportGuru from "./dashboard/content/guru/import/ImportGuru";
import MgtNilai from "./dashboard/content/snmptn/MgtNilai";
import SbmptnSekolah from "./dashboard/content/report/tryout/SbmptnSekolah";
import RekomendasiSbmptn from "./dashboard/content/report/tryout/RekomendasiSbmptn";
import Report from "./dashboard/content/report/tryout/akm/Report";
import ReportSiswa from "./dashboard/content/report/tryout/akm/ReportSiswa";
import ReportAsmDinas from "./dashboard/content/report/tryout/akm/ReportAsmDinas";
import ReportAsmDinasJadwal from "./dashboard/content/report/tryout/akm/ReportAsmDinasJadwal";
import ReportEnsaDinasJadwal from "./dashboard/content/report/tryout/ReportEnsaDinasJadwal";
import SiswaUrl from "./dashboard/content/siswa/SiswaUrl";
import Peminatan from "./dashboard/content/report/peminatan/Peminatan";
import ReportPeminatan from "./dashboard/content/report/peminatan/ReportPeminatan";
import ReportIq from "./dashboard/content/report/peminatan/ReportKU";
import ResetDurasiAndPengerjaan from "./dashboard/content/siswa/reset/ResetDurasiAndPengerjaan";
import Redis from "./dashboard/content/reset/Redis";
import Dinas from "./dashboard/content/report/dinas/";
import MonitoringStatusPengerjaan from "./dashboard/content/report/tryout/MonitoringStatusPengerjaan";
import ReportSekolahSta from "./dashboard/content/report/sta/ReportSekolahSta";
import FilterTa from "./dashboard/content/rekapitulasi/sta/FilterTa";
import RekapTa from "./dashboard/content/rekapitulasi/sta/RekapTa";
import RekapTa_Sma from "./dashboard/content/rekapitulasi/sta/RekapTa_Sma";
import RegistrasiPsep from "./dashboard/content/registrasi/RegistrasiPsep";
import VerifikasiEmail from "./dashboard/content/registrasi/VerifikasiEmail";
import ForgotPassword from "./dashboard/content/registrasi/ForgotPassword";
import PembelianPaket from "./dashboard/content/pembelianPaket";
import SuratPerintahKerja from "./dashboard/content/registrasi/SuratPerintahKerja";
// New Report
import ReportCbtNew from "../pages/Reports/Agcu/ReportAgcu";
import NewReportAsmSiswa from "../pages/Reports/Asm/Siswa/ReportSiswa";
import NewReportAsmSekolah from "../pages/Reports/Asm/Sekolah/ReportSekolah";
import ReportEnsaSiswa from "../pages/Reports/ensa/siswa/ReportSiswa";
import ReportEnsaSekolah from "../pages/Reports/ensa/sekolah/ReportSekolah";
import ReportEnsaDinas from "../pages/Reports/ensa/dinas/ReportDinas";
import NewReportPeminatan from "../pages/Reports/Peminatan/ReportPeminatan";
import ReportPemetaan from "../pages/Reports/Pemetaan/Pemetaan";
import ReportPemetaan2 from "../pages/Reports/Pemetaan2/Pemetaan";
import ReportPemetaan3 from "../pages/Reports/Pemetaan3/Pemetaan";
import ReportPemetaanGroup from "../pages/Reports/Pemetaan/PemetaanGroup";
import ReportPemetaanInput from "../pages/Reports/Pemetaan/index";
import ReportPemetaanInput2 from "../pages/Reports/Pemetaan2/index";
import ReportPemetaanInput3 from "../pages/Reports/Pemetaan3/index";
import ReportPemetaanKU from "../pages/Reports/Pemetaan/ReportKU";
import ListProdi from "./dashboard/content/snmptn/ListProdi";
import RekapSekolah from "../pages/Reports/TryOut/Snbt/RekapSekolah";
import ReportDinasSbnt from "../pages/Reports/Dinas/Snbt/ReportDinasSbnt";
import ReportDinasAGCU from "../pages/Reports/Dinas/AGCU/ReportDinasAGCU";
import RekomendasiSnmptn from "./dashboard/content/report/rekomendasi/RekomendasiSnmptn";
import ReportRekomendasiSnmptn from "./dashboard/content/report/rekomendasi/ReportRekomendasiSnmptn";
import ListEnsa from "./dashboard/content/report/tryout/ListEnsa";

class App extends React.Component {
    componentDidMount() {}

    render() {
        return (
            <div>
                <Router history={history}>
                    <Route path="/" exact component={Login} />
                    <Route path="/login" exact component={Login} />
                    <Route path="/dashboard" component={Dashboard} />
                    <Route path="/rekapitulasi/exam" component={Rekap} />
                    <Route path="/rekapitulasi/rekap_exam/:idJadwal/:idProfil/:idKelasParalel/:ta1/:ta2" component={RekapExam} />
                    <Route path="/rekapitulasi/rekap_exam_detail/:idJadwal/:idProfil/:idKelasParalel/:ta1/:ta2" component={RekapExamDetail} />
                    <Route path="/rekapitulasi/detailexamsiswa/:idSiswa/:idKp/:idJadwal" component={DetailExamSiswa} />
                    <Route path="/rekapitulasi/agcu/:idJadwal/:idProfil/:idKelas/:idKelasParalel/:ta1/:ta2" component={RekapAgcu} />
                    <Route path="/siswa" component={Siswa} />
                    <Route path="/cetakuser/:idSiswa" component={CetakAkunSiswa} />
                    <Route path="/siswaimport" component={ImportSiswa} />
                    <Route path="/upjen" component={UpdateJenjang} />
                    <Route path="/exam" component={Exam} />
                    <Route path="/examsoal/:id/:source" component={ExamSoal} />
                    <Route path="/examJadwal" component={JadwalExam} />
                    <Route path="/guru" component={Guru} />
                    <Route path="/addGuru" exact component={AddGuru} />
                    <Route path="/gurukelas" exact component={GuruKelas} />
                    <Route path="/gurumapel" exact component={Gurumapel} />
                    <Route path="/importguru" component={ImportGuru} />
                    <Route path="/kelas" component={Kelas} />
                    <Route path="/soal" component={MgtSoal} />
                    <Route path="/soal_upload" exact component={ImportSoal} />
                    <Route path="/soal_edit/:id/:iduploadhistory" component={EditSoal} />
                    <Route path="/homework" component={Homework} />
                    <Route path="/jadwalhw" component={JadwalHomework} />
                    <Route path="/reporthw" component={ReportHw} />
                    <Route path="/essaysiswa/:idsubheader/:idsiswa" component={KoreksiEssay} />
                    <Route path="/learning" component={Learning} />
                    <Route path="/learning_konten/:tipe" component={LearningKonten} />
                    <Route path="/mgtlearningsoal" component={SoalForm} />
                    <Route path="/mgtlearningteks" component={TeksForm} />
                    <Route path="/mgtlearningvideo" component={VideoForm} />
                    <Route path="/viewkonten/:tipe/:id" component={ViewKonten} />
                    <Route path="/rptagcu" component={ReportDinasAgcu} />
                    <Route path="/reportdinasagcu/:idKelas/:idProfilCbt" component={ReportDinasAgcuPreview} />
                    <Route path="/rpttoo" component={ReportDinasToo} />
                    <Route path="/reportdinastoo/:idKelas/:idProfilCbt/:type" component={ReportDinasTooPreview} />
                    <Route path="/live_report" component={ReportLive} />
                    <Route path="/bs" component={MigrasiBankSoal} />
                    <Route path="/bab" component={MigrasiBab} />
                    <Route path="/rstpgrjn" component={ResetPengerjaan} />
                    <Route path="/rstusrnm" component={ResetUsername} />
                    <Route path="/reporthwkelas/:idProfil/:idJadwalProfil/:idKp/:ta1/:ta2" component={ReportHwKelas} />
                    <Route path="/reporthwkelasexcel/:idProfil/:idJadwalProfil/:idKp/:ta1/:ta2" component={ReportHwExcel} />
                    <Route path="/reporthwdetail/:idProfil/:idJadwalProfil/:idKp/:ta1/:ta2" component={ReportHwDetailJawaban} />
                    <Route path="/report_tryout" component={ListJadwal} />
                    <Route path="/report_agcu" component={ListJadwal} />
                    <Route path="/report_sta" component={ListJadwal} />
                    <Route path="/report-sbmptn" component={ListJadwal} />
                    <Route path="/report_asm" component={ListJadwal} />
                    <Route path="/report_ensa" component={ListEnsa} />
                    <Route path="/report_ta" component={ListJadwal} />
                    <Route path="/getreportcbt/:tipeCbt/:idJadwalCbt/:idSekolah/:idKelas/:idKelasParalel" component={ReportCbt} />
                    {/* <Route path="/getreportsbm/:tipeCbt/:idJadwalCbt/:idSekolah/:idKelas/:kelompok" component={ReportCbt}/> */}
                    <Route path="/aktvuphis" component={Aktivitasuphis} />
                    <Route path="/aktvhw" component={AktivitasHw} />
                    <Route path="/cmpr" component={Comparasi} />
                    <Route path="/mgtvc" component={Vc} />
                    <Route path="/updatekp" component={UpdKelasParalelSiswa} />
                    <Route path="/mgtnilraport" component={MgtNilai} />
                    <Route path="/listprodisnmptn" component={ListProdi} />
                    <Route path="/sbmptnnon/:idKelas/:idJadwal/:kelompok" component={SbmptnSekolah} />
                    <Route path="/getrekomendasisbmptn/:idJadwal/:idSekolah/:idKelas/:kelompok" component={RekomendasiSbmptn} />
                    {/* <Route
                        path="/rptakm/:idJadwal/:idSekolah/:idKelas/:idKelasParalel"
                        component={Report}
                    /> */}
                    {/* <Route
                        path="/rptakmsiswa/:idSiswa/:idJadwal/:idSekolah/:idKelas/:idKelasParalel"
                        component={ReportAgcu}
                    /> */}
                    <Route path="/asmdinasreport/:idProfilCbt/:idDinasPemda/:kodeJenjangSekolah" component={ReportAsmDinas} />
                    <Route path="/ensadinasreport/:idProfilCbt/:idDinasPemda/:kodeJenjangSekolah" component={ReportEnsaDinas} />
                    <Route path="/asmdinas" component={ReportAsmDinasJadwal} />
                    <Route path="/ensadinas" component={ReportEnsaDinasJadwal} />
                    <Route path="/urlregsiswa" component={SiswaUrl} />
                    <Route path="/pmintan" component={Peminatan} />
                    <Route path="/rptpeminatan" component={ReportPeminatan} />
                    <Route path="/rptku/:idHeader/:idJadwal/:idSiswa" component={ReportIq} />
                    <Route path="/rstsw/" component={ResetDurasiAndPengerjaan} />
                    <Route path="/redis/" component={Redis} />
                    <Route path="/dinasagcu/" component={Dinas} />
                    <Route path="/monitoring" component={MonitoringStatusPengerjaan} />
                    <Route path="/rekap_ta" component={FilterTa} />
                    <Route path="/generate_rekap_ta/:idJadwalCbt/:idSekolah/:idKelas/:idKelasParalel/:kodeAspek" component={RekapTa} />
                    <Route path="/generate_rekap_ta_sma/:idJadwalCbt/:idSekolah/:idKelas/:idKelasParalel/:kodeAspek" component={RekapTa_Sma} />
                    <Route path="/sekolahsta" component={ReportSekolahSta} />
                    <Route path="/register-psep" component={RegistrasiPsep} />
                    <Route path="/verify-password" component={VerifikasiEmail} />
                    <Route path="/forgot-password" component={ForgotPassword} />
                    <Route path="/pembelian-paket" component={PembelianPaket} />
                    <Route path="/spk-sekolah" component={SuratPerintahKerja} />
                    {/* New Report */}
                    <Route path="/getreportcbtnew/:tipeCbt/:idJadwalCbt/:idSekolah/:idKelas/:idKelasParalel/:tahunAjaranFirst/:tahunAjaranSecond" component={ReportCbtNew} />
                    <Route path="/rptakmsiswa/:idSiswa/:idJadwal/:idSekolah/:idKelas/:idKelasParalel" component={NewReportAsmSiswa} />
                    <Route path="/rptensasiswa/:idSiswa/:idJadwal/:idSekolah/:idKelas/:idKelasParalel" component={ReportEnsaSiswa} />
                    <Route path="/rptakm/:idJadwal/:idSekolah/:idKelas/:idKelasParalel" component={NewReportAsmSekolah} />
                    <Route path="/rptensasekolah/:idSekolah/:idKelas/:idKelasParalel" component={ReportEnsaSekolah} />
                    <Route path="/report-peminatan" component={NewReportPeminatan} />
                    <Route path="/report_pemetaan" component={ReportPemetaan} />
                    <Route path="/report_pemetaan2" component={ReportPemetaan2} />
                    <Route path="/report_pemetaan3" component={ReportPemetaan3} />
                    <Route path="/report_pemetaan_group" component={ReportPemetaanGroup} />
                    <Route path="/report_pemetaan_input" component={ReportPemetaanInput} />
                    <Route path="/report_pemetaan_input2" component={ReportPemetaanInput2} />
                    <Route path="/report_pemetaan_input3" component={ReportPemetaanInput3} />
                    <Route path="/report_pemetaan_ku/:idSiswa/:idJadwal" component={ReportPemetaanKU} />
                    <Route path="/report_sbmptn/:idKelas/:idJadwal/:kelompok" component={RekapSekolah} />
                    <Route path="/report_dinas_sbmptn/:idKelas/:idJadwal/:kelompok" component={ReportDinasSbnt} />
                    <Route path="/report_dinas_agcu/:idKelas/:idJadwal/:kelompok" component={ReportDinasAGCU} />
                    <Route path="/rekomsnmptn" component={RekomendasiSnmptn} />
                    <Route path="/report_rekomendasi_snmptn/:kodeTahunAjaran1/:kodeTahunAjaran2/:idKelas/:idKelasParalel" component={ReportRekomendasiSnmptn} />
                </Router>
                <Bottom />
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        account: state.account,
    };
};
export default connect(mapStateToProps, { cekCookies })(App);
